import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToPosition(props) {
  const { xCord = 0, yCord = 0, behavior = 'smooth', history = {}, children } = props;

  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo({ top: yCord, right: xCord, behavior: behavior });
    });

    return () => {
      unlisten();
    };
  }, []);

  return children;
}

ScrollToPosition.propTypes = {
  xCord: PropTypes.number,
  yCord: PropTypes.number,
  behavior: PropTypes.string,
  history: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
};

export default withRouter(ScrollToPosition);
